import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export type AndamentoCompatibilidade = {
  id: number;
  origem: string;
  origemId: number;
  tipo: string;
  descricao: string;
  observacoes?: string;
  metadata?: any;
  criadoPor: {
    tipo: string;
    id?: number;
    nome?: string;
    email?: string;
    em: string;
  };
};

export const buscarAndamentosCompatibilidadeService = async (
  compatibilidadeId: number
): Promise<AndamentoCompatibilidade[]> => {
  if (!compatibilidadeId || compatibilidadeId <= 0) {
    console.warn("❌ ID inválido para buscar andamentos:", compatibilidadeId);
    return [];
  }

  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/compatibilidades/${compatibilidadeId}/andamentos`;

  console.log(`🔍 Buscando andamentos de compatibilidade #${compatibilidadeId} em: ${URL}`);

  try {
    const response = await axios.get(URL, {
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });

    if (!response || !response.data) {
      console.warn("⚠️ Resposta vazia do servidor");
      return [];
    }

    let data = response.data;

    // Suporta múltiplas estruturas de resposta
    if (data && typeof data === "object" && !Array.isArray(data)) {
      data = data.andamentos || data.data || data.resultado || [];
    }

    // Garante que é um array
    if (!Array.isArray(data)) {
      console.warn("⚠️ Resposta não é um array, convertendo...", data);
      data = [];
    }

    console.log(`✅ ${data.length} andamento(s) recebido(s):`, data);

    // Debug detalhado de cada andamento
    data.forEach((andamento: any, idx: number) => {
      console.log(
        `  [${idx}] tipo: ${andamento.tipo}, origem: ${andamento.origem}, origemId: ${andamento.origemId}, descricao: ${andamento.descricao}, criadoPor.nome: ${andamento.criadoPor?.nome || "SEM NOME"}`
      );
    });

    // Retorna ordenado por data (mais recente primeiro)
    // Filtra apenas andamentos da compatibilidade se necessário
    const filtered = (data as AndamentoCompatibilidade[])
      .filter((item) => {
        // Log detalhado do que está sendo filtrado
        console.log(`🔍 Filtrando item:`, {
          id: item?.id,
          origem: item?.origem,
          origemId: item?.origemId,
          compatibilidadeId: compatibilidadeId,
          match: item && item.id && item.origemId === compatibilidadeId,
        });
        return item && item.id && item.origemId === compatibilidadeId;
      }) // Remove items inválidos
      .sort((a: AndamentoCompatibilidade, b: AndamentoCompatibilidade) => {
        try {
          const dataA = a.criadoPor.em ? new Date(a.criadoPor.em).getTime() : 0;
          const dataB = b.criadoPor.em ? new Date(b.criadoPor.em).getTime() : 0;
          return dataB - dataA;
        } catch (error) {
          console.warn("⚠️ Erro ao ordenar datas:", error);
          return 0;
        }
      });
    
    console.log(`📊 Após filtrar: ${filtered.length} itens (de ${data.length} recebidos)`);
    return filtered;
  } catch (error: any) {
    console.error("❌ Erro ao buscar andamentos:", {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
      url: URL,
    });

    if (error?.response?.status === 404) {
      console.warn("⚠️ Compatibilidade não encontrada ou sem andamentos");
    }

    return [];
  }
};
